import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const Cotitular: FC = () => {
  return <>{SystemManager.getSystem('tarjeta-cotitular')}</>;
};

export default Cotitular;
